import React from 'react'

const Paryaparyatankasambhabanaraayam = () => {
  return (
    <div>
      <div>
        <h3>शब्दभण्डार</h3>
        <h5>१. दिइएका शब्द र अर्थबिच जोडा मिलाउनुहोस्:</h5>
        <p>(क) परिस्थितिक प्रणाली : परिस्थितिका कारण निम्तिने प्रणाली</p>
        <p>(ख) विहङ्गम दृष्टि : आकाशमा उडिरहेको चराले जस्तै कुनै कुरालाई हेर्ने काम</p>
        <p>(ग) तृणहारी : दुबो, पराल, खर आदि घाँसपात खाने</p>
        <p>(घ) कटिबन्ध : पृथ्वीका दुई ध्रुवका बिचका भुभागलाई हावापानी आदिका हिसाबले बाँडिने भाग</p>
        <p>(ङ) पर्यापर्यटन : विविधताका कारण हुने पर्यटन</p>
        <p>(च) जलक्रीडा : पानीमा गर्न सकिने विभिन्न खेल; मनोरञ्जन</p>
        <p>(छ) पर्यावरणमैत्री :वातावरण सुहाउँदो</p>
        <p>(ज) प्रतिकूल प्रभाव : पक्षमा नभएको प्रभाव</p>
        <p>(झ) हिमाच्छादित छाना : हिउँ नै हिउँले ढाकिएको छाना</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका शब्दहरुको अर्थ शब्दकोशका सहायताले पत्ता लगाउनुहोस् :</h5>
        <p>लवज : भन्ने तरिका, बोल्ने तरिका</p>
        <p>वायुमण्डल : हावाले ढाकेको भाग</p>
        <p>संजाल : जालो</p>
        <p>लीन : काममा एकाग्र भएर लागेको, तल्लीन</p>
        <p>नभचर : आकाशमा बस्ने</p>
        <p>अक्षांश : पृथ्वीको सतहमा पूर्वपश्चिम खिचिएका काल्पनिक रेखा</p>
        <p>शीतोष्ण : समुन्द्र सतहबाट २००० देखि ३००० मिटरसम्मको भाग</p>
        <p>सिमसार : हिलो र पानी भएको ठाउँ</p>
      </div>
      <hr/>
      <div>
        <h5>३. पाठबात दशओटा आगन्तुक शब्द पहिचान गरी वाक्यमा प्रयोग गर्नुहोस् :</h5>
        <strong>ग्रीक</strong>
        <p>ग्रीक सभ्यता विश्वकै प्राचीन सभ्यतामध्ये एक हो।</p>
        <strong>र्‍याफि्टङ</strong>
        <p>म साथीहरूसँग ट्रीसुली नदीमा र्‍याफ्टिङ गर्न गएँ।</p>
        <strong>बोटिङ</strong>
        <p>फेवातालमा बोटिङ गर्दा निकै रमाइलो अनुभव भयो।</p>
        <strong>बन्जी जम्पिङ</strong>
        <p>बन्जी जम्पिङ गर्न साहसिक आत्मबल चाहिन्छ।</p>
        <strong>गल्फ</strong>
        <p>गल्फ देशहरूमा धेरै नेपालीहरू रोजगारीको सिलसिलामा जान्छन्।</p>
        <strong>इकोफ्रेन्ड्ली</strong>
        <p>हामीले इकोफ्रेन्ड्ली सामग्री प्रयोग गर्नुपर्छ।</p>
        <strong>इकोटुरिजम</strong>
        <p>नेपालमा इकोटुरिजम प्रवर्द्धन गरेर वातावरणमैत्री पर्यटन सम्भव छ।</p>
        <strong>इकोलोजी</strong>
        <p>इकोलोजीको सन्तुलन बिग्रँदा जैविक विविधता प्रभावित हुन्छ।</p>
        <strong>इकोसिस्टम</strong>
        <p>वन विनाशले इकोसिस्टममा ठूलो असर पुर्याउँछ।</p>
        <strong>मैदान</strong>
        <p>बच्चाहरू खुला मैदानमा फुटबल खेलिरहेका थिए।</p>
      </div>
      <hr/>
      <div>
        <h5>४. पाठबाट पर्यटन र पर्यावरणसँग सम्बन्धित दश दशओटा शब्द पहिचान गरी लेख्नुहोस् :</h5>
        <h5>पर्यटन</h5>
        <p>र्‍याफि्टङ, कायाकिङ, क्यानोइङ, बोटिङ, मत्स्यविहार, बाइक यात्रा, घोडसवार, रक क्लाइम्बिङ, हिउँचिप्लेटी, गल्फ</p>
        <h5>पर्यावरण</h5>
        <p>पोखरी, ताल, सिसिमसार, वनस्पति, घाँस, पात, पशुपन्छी, स्थलचर, जङ्गल, जलथर</p>
      </div>
      <hr/>
      <div>
        <h3>बोध र अभिव्यक्ति</h3>
        <h5>१. दिइएका प्रश्नको उत्तर दिनुहोस् :</h5>
        <h5>(क) पर्यापर्यटन पाठ कति अनुच्छेदमा संरचित छ ?</h5>
        <p>= पर्यापर्यटन पाठ दस अनुच्छेदमा संरचित छ ।</p>
        <h5>(ख) सबैभन्दा लामो अनुच्छेद कुन हो र कति वाक्यमा संरचित छ ?</h5>
        <p>= सबैभन्दा लामो अनुच्छेद नवौ हो र यो ९ वाक्यमा संरचित छ ।</p>
        <h5>(ग) सबैभन्दा छोटो अनुच्छेदमा कति वाक्यहरु छन् र कुन हो ?</h5>
        <p>= सबैभन्दा छोटो अनुच्छेदमा ३ वाक्यहरु छन र यो दशौ अनुच्छेद हो ।</p>
      </div>
      <hr/>
      <div>
        <h5>२. दिइएका विषय सन्दर्भ कुन कुन अनुच्छेदमा छन् ?</h5>
        <p>(अ) दोस्रो अनुच्छेद</p>
        <p>(आ) पाँचौ अनुच्छेद</p>
        <p>(इ) छैटौं अनुच्छेद</p>
        <p>(ई) पहिलो अनुच्छेद</p>
        <p>(उ) दसौं अनुच्छेद</p>
        <p>(ऊ) नवौं अनुच्छेद</p>
      </div>
      <hr/>
      <div>
        <h5>३. पाठको दोस्रो अनुच्छेद पढ्नुहोस् र सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) जलचरहरु के खाएर बाँच्छन् ?</h5>
        <p>= जलचरहरु घाँस, पात, लेउ र झ्याउ खाएर बाँच्छन् ।</p>
        <h5>(ख) जमिनले पोषण कसरी प्राप्त गर्दछ ?</h5>
        <p>= जमिनले पशुपन्छी वा वनस्पति मरेर, सडेरपछि पोषण प्राप्त गर्दछ ।</p>
        <h5>(ग) आहारको सन्जाल कसरी निर्माण हुन्छ ?</h5>
        <p>= चक्रीय पारिस्थितिक प्रणालीद्वारा आहाराको सञ्जाल निर्माण भएको हुन्छ ।</p>
        <h5>(घ) प्राणीहरु किन जन्मन्छ्न् र मर्छन् ?</h5>
        <p>= परिस्थितिक प्रणालीलाई सन्तुलनमा राख्नका लागि प्राणीहरु जन्मन्छन् र मर्छन् ।</p>
      </div>
      <hr/>
      <div>
        <h5>४. दिइएको निबन्धांश पढी सोधिएका प्रश्नहरुको छोटो उत्तर दिनुहोस् :</h5>
        <h5>(क) पृथ्वी नै सबैको साझा घर हो, कसरी ?</h5>
        <p>= पृथ्वी एक मात्र जीवित ग्रह हो । यहाँ जल स्थल, वायु, आकाश र तेज जस्ता पञ्चतत्त्वहरू छन् । यिनै तत्त्वहरुको बिचमा जलचर, स्थलचर, नभचर र सबै चराचरले आफ्नो जीवन बिताउने भएकाले पृथ्वी नै सबैको साझा घर हो ।</p>
        <h5>(ख) वायुमण्डल प्रदुषणका कारण पृथ्वीको सतह अप्रत्यासित ढङ्गले तात्ने क्रमलाई लिएर किन चासो र चिन्ता बढेको छ ?</h5>
        <p>= पृथ्वी एक मात्र जीवित ग्रह हो । पृथ्वीको परिस्थितिक प्रणालीमा गडबडी भएमा प्राणी र वन्स्पतिको अस्तित्व सङ्कटमा पर्छ । हाल वायुमण्डल प्रदूषणका कारण पृथ्वीको सतह अप्रत्यासित ढङ्गले तात्न थालेको छ, जलवायु परिवर्तन भएको छ, पारिस्थितिक प्रणाली नै बिथोलिएको छ, मानिस लगायत सम्पूर्ण प्राणी एवं वनस्पति जगत नै प्रभावित भएको छ । यो क्रम रोकिएन भने मानव अस्तित्व नै सङ्कटमा पर्ने भएकाले यसप्रति चासो र चिन्ता बढेको छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएको निबन्धांश पढी सोधिएका प्रश्नहरुको छोटो उत्तर दिनुहोस् :</h5>
        <h5>(क) पर्यटकीय गतिविधिका क्षेत्रहरु के के हुन् ?</h5>
        <p>= पर्यटकीय गतिविधिका क्षेत्रहरु जल, स्थल र आकाश हुन् । पर्वतारोहण, पदयात्रा, जङ्गलसफारी, वन्यजन्तु अवलोकन, पर्वतीय बाइकयात्रा, घोडसवार, रक क्लाइम्बिङ, प्राकृतिक गुफा अन्वेषण, हिउँ चिप्लेटी, जलक्रीडा, न्याफ्टिड, बोटिङ, मत्स्य विहार, पर्वतीय उडान, पाराग्लाइडिङ हट एयर बेलुन, बन्जी जम्पिङ आदि पर्यटकीय गतिविधिका क्षेत्रहरू हुन् ।</p>
        <h5>(ख) पर्यापर्यटनका निम्ति आचारसंहिता कसलाई र किन आवश्यक छ ?</h5>
        <p>= पर्यापर्यटनका निम्ति आचारसंहिता पर्यटन व्यवसाय गर्ने र पर्यटक भएर आउने दुवै पक्षलाई आवश्यक छ । हामीले गर्ने प्रत्येक क्रियाकलापहरुले हाम्रो पारिस्थितिक प्रणालीमा प्रत्यक्ष सम्बन्ध राख्ने भएकाले हाम्रो पारिस्थितिक प्रणालीलाई स्वस्थ र दीगो बनाइ राख्न पर्यटन व्यवसायमा संलग्न सम्पूर्ण व्यवसायीलाई पर्यावरणमैत्री नीति, नियम, कानुन र आचारसंहिताको पालना गर्न आवश्यक छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>६. उत्तर दिनुहोस् :</h5>
        <h5>(क) जलवायुका दृष्टिकोणले पृथ्वीलाई कसरी वर्गीकरण गरिएको छ ?</h5>
        <p>= जलवायुका दृष्टिकोणले पृथ्वीलाई भूमध्यरेखाको उत्तर तथा दक्षिणतिर उष्ण, उपउष्ण, शीतोष्ण एवम् हिमाच्छादित ध्रुवीय कटिवन्धनहरू भनी वर्गीकरण गरिएको छ । हिमालय क्षेत्रमा १००० मिटरभन्दा होचो भागमा उष्ण जलवायु, त्यसभन्दा उच्च भूभागमा २००० मिटरसम्म उपउष्ण जलवायु, त्यसभन्दा उच्च क्षेत्रमा ३००० मिटरसम्म शीतोष्ण कटिबन्ध, त्यसभन्दा माथिको शीतप्रधान कटिबन्ध उपलेकाली ४००० मिटरसम्म र त्यहाँबाट ५००० मिटरसम्म हावापानी, ५००० मिटरभन्दा उच्च भागमा हिमाच्छादित क्षेत्र हुन्छ भनी वर्गीकरण गरिएको छ |</p>
        <h5>(ख) पर्यापर्यटनका विशेषताहरु उल्लेख गर्नुहोस् ।</h5>
        <p>= पर्यापर्यटनका विशेषताहरु निम्न छन् :</p><p>
1. प्राकृतिक सम्पदाको संरक्षण र सम्वदनलाई आर्थिक रूपमा सहयोग मिलेको छ ।</p><p>
2. सांस्कृतिक सम्पदाको संरक्षण भएको छ ।</p><p>
3. अन्तर्राष्ट्रिय सद्भाव र भाइचारालाई उच्च बनेको छ ।</p><p>
4. मानिसहरुलाई यो व्यवसायबाट रोजगारी मिलेको छ ।</p>
<h5>(ग) जल, थल र आकाशमा हुने पर्यटकीय गतिविधिहरु उल्लेख गर्नुहोस् ।</h5>
<p>जलमा हुने पर्यटकीय गतिविधिहरु : र्‍याफि्टङ, कायाकिङ, क्यानोनिङ, बोटिङ, मत्स्य विहार आदि ।</p>
<p>थलमा हुने पर्यटकीय गतिविधिहरु : पर्वतारोहण, पदयात्रा ,जङ्गलसफारी, वन्यजन्तु अवलोकन, पर्वत वाइक यात्रा आदि ।</p>
<p>आकाशमा हुने पर्यटकीय गतिविधिहरु : पर्वतीय उडान, ह्यन्ड ग्लाइडिङ, पाराग्लाइडिङ, हट एयर बेलून आदि ।</p>
<h5>(घ) नेपालको पर्यावरणको विविधतालाई निबन्धमा कसरी वर्णन गरिएको छ ?</h5>
<p>= नेपालको पर्यावरणको विविधताको वर्णन पाँचतले घरसँग तुलना गरेर गरिएको छ । भुईतलामा तराई, पहिलो तलामा चुरे मधेश तथा टारवेंसी दोस्रो तलामा पहाडी प्रदेश, तेस्रो तलामा पर्वतीय प्रदेश, चौथो तलामा उच्च पर्वतीय भाग र त्यसको शिरमा हिमाच्छादित छानाका रूपमा निबन्धमा वर्णन गरिएको छ । यसको उत्तरी मोहडामा बार्दली झै निस्किएको भोट प्रदेशको आकर्षण छ भन्ने कुरालाई यस निबन्धमा व्यक्त गरिएको छ ।</p>
      </div>
      <hr/>
      <div>
        <h3>७. व्याख्या गर्नुहोस् :</h3>
        <h5>(क) पृथ्वीको ………………………….सङ्कटमा पर्छ ।</h5>
        <p>= प्रस्तुत गद्यांश कक्षा ११ को नेपाली पाठ्यपुस्तकअन्तर्गत पर्ने "पर्यापर्यटनका सम्भावना र आयाम" शीर्षकको निबन्धबाट साभार गरिएको हो। यस निबन्धका लेखक तीर्थबहादुर श्रेष्ठ हुन्। उनले प्रकृति, वातावरण, पारिस्थितिकी प्रणाली र पर्यावरण संरक्षणको विषयमा गहिरो चिन्ता व्यक्त गरेका छन्। निबन्धमा पृथ्वीलाई सबै जीवहरूको साझा घर मानेर यसको संरक्षणमा सबैको जिम्मेवारी रहेको कुरा उल्लेख गरिएको छ।</p>
        <p>पृथ्वी एक मात्र जीवनयुक्त ग्रह हो, जहाँ जल, वायु, माटो, सूर्यजस्ता पञ्चतत्त्वहरू जीवहरूको अस्तित्वका लागि अनिवार्य छन्। यी तत्त्वमा कुनै असन्तुलन आएमा जीव, वनस्पति, र मानवीय अस्तित्व नै संकटमा पर्छ। मान्छेले विकासका नाममा अन्धाधुन्ध दोहन गरेर वातावरणमा गम्भीर असर पुर्‍याइरहेका छन्। यो क्रम जारी रह्यो भने पृथ्वीको पारिस्थितिक प्रणाली बिचलित भई सम्पूर्ण जैविक सन्तुलन बिग्रन सक्छ।</p>
        <p>यस निबन्धमार्फत लेखकले पृथ्वीलाई साझा घर मानी सबै मानव समुदायलाई यसको संरक्षणका लागि चेतना जगाउने प्रयास गरेका छन्। वातावरणीय असन्तुलनको असर हाम्रो भविष्यमा गम्भीर रूपमा पर्ने भएकाले आजैदेखि सचेत हुन जरुरी छ। यदि हामीले प्रकृतिप्रतिको सम्बन्धलाई नबुझेमा, पृथ्वीको पारिस्थितिक प्रणाली बिथोलिएर हाम्रो अस्तित्व नै संकटमा पर्न सक्छ। त्यसैले पृथ्वीलाई जोगाउनु हाम्रो कर्तव्य हो।</p>
      </div>
      <hr/>
      <div>
        <h5>(ख) नयाँ पिँढिको ………………………. माग पनि हो ।</h5>
        <p>= यो गद्यांश कक्षा ११ को नेपाली पाठ्यपुस्तकमा समावेश "पर्यापर्यटनका सम्भावना र आयाम" शीर्षकको निबन्धबाट लिइएको हो, जसका लेखक तीर्थबहादुर श्रेष्ठ हुन्। उनले वातावरण, पर्यटन र प्राकृतिक स्रोतको सन्तुलित प्रयोगको पक्षमा लेख लेख्दै, पृथ्वीलाई हाम्रो साझा घर मानेर संरक्षण गर्नुपर्ने आवश्यकता औंल्याएका छन्।</p>
        <p>नेपालमा रोजगारीको अभाव, गरिबी, र सीप अभावको कारण युवाशक्ति विदेश पलायन भइरहेको छ। धेरै गाउँहरूमा त यो परम्परा जस्तै बनेको छ| कामका लागि विदेश जाने र फर्किने। लेखकले सुझाएका छन् कि यदि स्थानीय सरकारहरूले सीपमूलक तालिम, लगानीको अवसर र पर्यटनसँग सम्बन्धित स्वरोजगारका विकल्पहरू सिर्जना गर्न सके, भने युवा पुस्तालाई देशमै रोक्न सकिन्छ। पर्यापर्यटन विकासले युवाहरूलाई स्वदेशमै आत्मनिर्भर बनाउने अवसर दिन्छ।</p>
        <p>युवाशक्तिलाई देशमै अवसर दिएर स्वदेशमै उपयोग गर्न सके राष्ट्रको समृद्धि सम्भव छ। यस्तो कार्यले न केवल युवालाई रोजगारी दिन्छ, तर देशको आर्थिक, पर्यावरणीय र सांस्कृतिक संरक्षणमा समेत योगदान पुर्‍याउँछ। त्यसैले पर्यापर्यटनको प्रवर्द्धन अब केवल वातावरण संरक्षणको आवश्यकता मात्र नभई नयाँ पिँढीको सपना, सम्भावना र माग पनि हो।</p>
      </div>
      <hr/>
      <div>
        <h3>८. समीक्षात्मक उत्तर लेख्नुहोस् :</h3>
        <h5>(क) नेपालको पर्यावरणले पर्यटनलाई कसरी सहयोग पुर्‍याएको छ ?</h5>
        <p>= नेपालको पर्यावरण, यसको भौगोलिक विविधता, प्राकृतिक सम्पदा र सांस्कृतिक सम्पत्तिहरूले पर्यटन क्षेत्रको विकासमा अत्यन्तै महत्वपूर्ण भूमिका खेलेको छ। यहाँका हिमाल, पहाड, तराई, खोला, झरना, जडीबुटी, बनजंगल, जैविक विविधता र सौन्दर्यपूर्ण वातावरणले स्वदेशी तथा विदेशी पर्यटकहरूलाई आकर्षित गर्दै आएका छन्।</p>
        <p>नेपालमा संसारकै सर्वोच्च शिखर सगरमाथा, प्रसिद्ध पदमार्गहरू जस्तै अन्नपूर्णा, मनास्लु, लाङटाङ, रारा जस्ता सुन्दर स्थलहरू छन्, जसले साहसिक पर्यटकहरूलाई लोभ्याउँछ। यस्तै, लुम्बिनी जस्तो धार्मिक स्थलले बौद्ध धर्मालम्बीहरूलाई तानिरहेको छ। त्यस्तै, यहाँको शान्त, स्वच्छ र प्राकृतिक वातावरण, विविध जातजातिको संस्कृति, परम्परा र आतिथ्य भावले पर्यटकलाई खास अनुभव प्रदान गर्छ।</p>
        <p>यसरी नेपालमा रहेको समृद्ध र स्वाभाविक पर्यावरणले साहसिक, धार्मिक, प्राकृतिक, सांस्कृतिक सबै प्रकारका पर्यटन विकासमा सहयोग पुर्‍याएको छ। पर्यावरणीय सम्पदाहरूको संरक्षण र प्रवर्द्धनले पर्यटन व्यवसायलाई अझ सशक्त बनाउँदै आएको छ।</p>
      </div>
      <hr/>
      <div>
        <h5>(ख) नेपालको पर्यापर्यटनको विकासमा स्थानीय, समुदाय तथा सरकारको भूमिका उल्लेख गर्नुहोस् ।</h5>
        <p>= नेपाल जैविक, सांस्कृतिक र प्राकृतिक विविधताले भरिपूर्ण देश हो। यहाँको हिमाल, पहाड, तराई, र विविध जातजातिका परम्परा र संस्कृतिले पर्यटकीय सम्भावनालाई अझ बलियो बनाएको छ। यस्तो संभावना बोकेको मुलुकमा पर्यापर्यटनको विकास गर्न स्थानीय, समुदाय र सरकारको विशेष भूमिका आवश्यक हुन्छ।</p>
        <p>स्थानीय समुदायले आफ्नो क्षेत्रको सांस्कृतिक सम्पदा, पर्यावरण, धार्मिक स्थल, परम्परा, भाषा र आतिथ्य सत्कारलाई संरक्षण गर्नुपर्छ। गाउँ–बस्तीमा होमस्टे कार्यक्रम, स्थानीय गाइड, हस्तकलाका सामग्री र जैविक उत्पादनले पर्यटकलाई लोभ्याउन सकिन्छ। यस्तै, पर्यटन क्षेत्रले दिने रोजगारी र आम्दानीबाट स्थानीयले प्रत्यक्ष लाभ लिन सक्नेछन्।</p>
        <p>त्यस्तै, सरकारको भूमिका नीति निर्माण, पूर्वाधार विकास (सडक, विद्युत्, सञ्चार), वातावरणीय सुरक्षा र पर्यटन प्रवर्द्धनमा केन्द्रीत हुनुपर्छ। नेपाल सरकारले पर्यापर्यटनलाई प्राथमिकतामा राखी वातावरणमैत्री नीति बनाउनु, स्थानीय तहसँग सहकार्य गर्नु र अन्तर्राष्ट्रिय बजारमा नेपालको प्रवर्द्धन गर्नु जरुरी छ। यसरी सबैको संयुक्त प्रयासले नेपालको पर्यापर्यटन क्षेत्रलाई समृद्ध बनाउँदै देशको समग्र आर्थिक विकासमा योगदान दिन सकिन्छ।</p>
      </div>
      <hr/>
      <div>
        <h5>९. दिइएको अनुच्छेद पढी कुनै पाँचओटा प्रश्न निर्माण गर्नुहोस् ।</h5>
        <p>१. यार्सागुम्बा कस्तो जडीबुटी हो ?</p>
        <p>२. यार्सागुम्बा कस्तो स्थानमा पाइन्छ ?</p>
        <p>३. यार्सागुम्बाको स्वरुप सुरुमा कस्तो हुन्छ ?</p>
        <p>४. यार्सागुम्बा के कारणले अनौठो जीव हो ?</p>
        <p>५. यार्सागुम्बाबाट देशले कसरी फाइदा लिन सक्छ ?</p>
      </div>
      <hr/>
      <div>
        <h5>१०. दिइएको अनुच्छेद पढी अन्त्यमा सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) भौतिक विज्ञानका प्रणेता को को हुन् ?</h5>
        <p>= भौतिक विज्ञानका प्रणेता न्युटन, ग्यालिलियो र आइन्स्टाइन हुन् । </p>
        <h5>(ख) भौतिक विज्ञानका आधारमा शक्ति र बलमा के भिन्नता छ ?</h5>
        <p>= भौतिक विज्ञानका आधारमा शक्ति भनेको कार्य गर्ने सामर्थ्यको नाप हो भने बल भनेको एकसमान गतिलाई बदल्ने एकाइ हो ।</p>
        <h5>(ग) माथिको अनुच्छेदबाट दुईवटा तत्सम शब्द टिप्नुहोस् र तिनको बनोट देखाउनुहोस ।</h5>
        <p>समुद्रपारि : समुद्रदेखि पारि</p>
        <p>जीवनजगत : जीवन र जगत</p>
        <h5>(घ) भौतिक विज्ञानले कसरी प्रकृतिको व्यापक क्षेत्रलाई समेटेको छ ?</h5>
        <p>= भौतिक विज्ञानले स्थान, काल, गति, विद्युत्, प्रकाश, ऊर्जा, भूगर्भ, खगोल, प्रकृति, जीवनजगत तथा ब्रह्माण्ड समेतको अध्ययन गरेकाले यसले प्रकृतिको व्यापक क्षेत्रलाई समेट्न सफल भएको छ ।</p>
        <h5>(ङ) `भूगर्भ´ र `खगोल´ शब्दको अर्थ लेख्नुहोस् ।</h5>
        <p>भूगर्भ : पृथ्वीको भित्री तह</p>
        <p>खगोल : आकाश, अन्तरीक्ष</p>
      </div>
      <hr/>
      <div>
        <h5>१२. दिइएको अनुच्छेद पढ्नुहोस र सोधिएका प्रश्नहरुको उत्तर दिनुहोस् :</h5>
        <h5>(क) आधारभूत रुपमा अनुच्छेद कति किसिमका हुन्छन् ?</h5>
        <p>= आधारभूत रुपमा अनुच्छेद आत्मपरक र वस्तुपरक गरी दुई किसिमका हुन्छन् ।</p>
        <h5>(ख) कस्तो अनुच्छेदलाई आत्मपरक अनुच्छेद भनिन्छ ?</h5>
        <p>= प्रथमपुरुष दृष्टिविन्दु प्रयोग भएको लेखकको निजि विचार प्रधान गर्ने अनुच्छेदलाई आत्मपरक अनुच्छेद भनिन्छ ।</p>
        <h5>(ग) अनुच्छेदमा वस्तुपरक विषयलाई कसरी वर्णन गरिएको छ ?</h5>
        <p>= अनुच्छेदमा वस्तुपरक विषयलाई तृतीयपुरुष दृष्टिविन्दु र तथ्यगत रुपमा वर्णन गरिएको छ ।</p>
        <h5>(घ) आत्मपरक अनुच्छेद र वस्तुपरक अनुच्छेदबिचको मुख्य अन्तर के हो ?</h5>
        <p>= आत्मपरक अनुच्छेदमा लेखकको विचार वा अनुभूतिलाई प्राथमिकता दिइन्छ भने वस्तुपरक अनुच्छेदमा सत्य तथ्य वस्तु वा घटनालाई आधार बनाइन्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>१३. दिइएको अनुच्छेद आत्मपरक हो भन्ने आधार के के छन् ,पुष्टि गर्नुहोस् :</h5>
        <p>दिइएको अनुच्छेदमा प्रथम पुरुष दृष्टिविन्दु प्रयोग भएको छ । साथै प्रकृतिलाई मानिस जस्तै मानेर कञ्चनजङ्घा, पहाडी टार, जबरे खोलाको सङ्गीतको चित्रण गरिएको छ । पानीलाई अमृत मान्नु, आफ्नो गाउँलाई स्वर्ग ठान्नु जस्ता आधारले दिइएको अनुच्छेद आत्मपरक अनुच्छेद हो भन्न सकिन्छ ।</p>
      </div>
      <hr/>
      <div>
        <h5>१४. दिइएको अनुच्छेद वस्तुपरक हो भन्ने आधार के के छन् ,पुष्टि गर्नुहोस् :</h5>
        <p>दिइएको अनुच्छेदमा तृतीय पुरुष दृष्टिविन्दु प्रयोग भएको छ । साथै सत्यतथ्यमा आधारित रहेर पहिले सूचनाका लागि पङ्क्षी, वाद्यवादनलाई प्रयोग गरि लेखकले तथ्यगत रुपमा विषयवस्तुको पुष्टि गरेको हुनाले दिइएको अनुच्छेद वस्तुपरक अनुच्छेद हो भन्न सकिन्छ ।</p>
      </div>
      <hr/>
      <div>
        <h3>व्याकरण अभ्यास</h3>
        <h5>१. दिइएको अनुच्छेद पढी उपसर्ग लागेका शब्द पहिचान गर्नुहोस् :</h5>
        <p>विलक्षण, सम्पन्न, विशिष्ट, संरचना, अपार, विभिन्न, सुलभ, दुर्लभ, अनेक, प्रकृति, प्रदत्त, सम्पदा , अत्यन्त, समृद्ध आदि ।</p>
      </div>
      <hr/>
      <div>
        <h3>२. दिइएको अनुच्छेदबाट दशओटा उपसर्ग व्युत्पन्न शब्द छानी निर्माण प्रक्रिया देखाउनुहोस् :</h3>
        <p>प्रतिवर्ष, अवलोकन, अतिथि, स्वागत, उपस्थिति, प्रतिकूल, प्रभाव, पर्यटन, सचेत, आधार ।</p>
      </div>
      <hr/>
      <div>
        <h5>उपसर्ग आधार पद व्युत्पन्न शब्द</h5>
        <p>प्रति + वर्ष : प्रतिवर्ष</p>
        <p>अब + लोकन : अवलोकन</p>
        <p>अ + तिथि : अतिथि</p>
        <p>सु + आगत : स्वागत</p>
        <p>उप + स्थिति : उपस्थिति</p>
        <p>प्रति + कूल : प्रतिकूल</p>
        <p>प्र + भाव : प्रभाव</p>
        <p>परि + अटन : पर्यटन</p>
        <p>स + चेत : सचेत</p>
        <p>आ + धार : आधार</p>
      </div>
      <hr/>
      <div>
        <h5>३. 'पर्यापर्यटनका सम्भावना र आयाम ' पाठको पहिलो अनुच्छेदमा रहेका उपसर्ग व्युत्पन्न शब्द पहिचान गरी निर्माण प्रक्रिया देखाउनुहोस् :</h5>
        <p>प्रतिवर्ष : प्रति + वर्ष</p>
        <p>सन्तुलन : सम् + तुलन</p>
        <p>प्रयोग : प्र + योग</p>
        <p>आधार : आ + धार</p>
        <p>अनुसन्धान : अनु + सन्धान</p>
        <p>निर्माण : निर् + माण</p>
        <p>परिवेश : परि + वेश</p>
        <p>प्रक्रिया : प्र + क्रिया</p>
        <p>सम्बन्ध : सम् + बन्ध</p>
        <p>उपसर्ग : उप + सर्ग</p>
        <p>अभिव्यक्ति : अभि + व्यक्ति</p>
        <p>अध्ययन : अधि + अयन</p>
        <p>परिचर्चा : परि + चर्चा</p>
        <p>अनुसार : अनु + सार</p>
        <p>निर्जीव : निर् + जीव</p>
        <p> संहार : सं + हार </p>
      </div>
      <hr/>
      <div>
        <h5>५. दिइएका उपसर्ग लगाई शब्द निर्माण गर्नुहोस् :</h5>
        <p>अधि + कार : अधिकार</p>
        <p>दुर् + गम : दुर्गम</p>
        <p>दुस् + सहास : दुस्साहस</p>
        <p>निस् + कपट : निष्कपट</p>
        <p>अ + स्वीकार : अस्वीकार</p>
        <p>उत् + पन्न : उत्पन्न</p>
        <p>सु + गम : सगम</p>
        <p>आ + कार : आकार</p>
        <p>सम् + मान : सम्मान</p>
      </div>
      <hr/>
      <div>
        <h5>६. अ, अन, कु, बे, ब, बद, गैर, ना, स उपसर्ग लागाई शब्द बनाउनुहोस् । यसरी बनेका शब्द प्रयोग गरी अनुच्छेद रचना गर्नुहोस् :</h5>
        <p>अ + विवाहित : अविवाहित</p>
        <p>अन + मेल : अनमेल</p>
        <p>कु + चेष्टा : कुचेष्टा</p>
        <p>बि + चल्ली : बिचल्ली</p>
        <p>बे + इज्जत : बेइज्जत</p>
        <p>बद् + नाम : बदनाम</p>
        <p>गैर + जिम्मेवार : गैरजिम्मेवार</p>
        <p>ना + मर्द : नामर्द</p>
        <p>स + चेत : सचेत</p>
        <h5>अनुच्छेद रचना :</h5>
        <p>अविवाहित रामले अनमेल विवाह गर्ने कुचेष्टा गरेकाले समाजले उसलाई कारवाही गरेपछि उसको बेइज्जत मात्र नभएर बदनाम नै भएपछि सचेत हुनुको साटो ऊ गैरजिम्मेवार बनी नामर्द झै कुलतमा सक्रिय भई बिचल्लीमा परेको देखिन्छ ।</p>
      </div>
    </div>
  )
}

export default Paryaparyatankasambhabanaraayam
